import React from 'react'
import { ForEachModel, useValue, ValueToCollection } from '@morningtrain/react-resources'
import StepPointOption from 'pages/app/cleaning/partials/StepPointOption'
import { FlexGrid } from 'ui/layouts'

export default function StepPointOptions ({ isCompleted }) {
  const stepId = useValue('id')
  const points = useValue('points', null)

  return (
    <FlexGrid grow cols={2} responsive={{ sm: 4 }} className=''>
      <ValueToCollection name='options'>
        <ForEachModel>
          <StepPointOption stepId={stepId} points={points} isCompleted={isCompleted} />
        </ForEachModel>
      </ValueToCollection>
    </FlexGrid>
  )
}
